import styled from 'styled-components';

interface Props {
  space?: string;
  justify?: string;
}

const HorizontalContent = styled('div').attrs<Props>({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props: Props) => props.justify || 'normal'};

  && {
    > * + * {
      margin-left: ${(props: Props) => props.space || 'var(--s-2)'};
    }
  }
`;

export default HorizontalContent;
